// src/components/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // only effect, no UI
  }, [pathname]);

  return null; // 👈 make sure this is here
};

export default ScrollToTop;
